import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { EXTERNAL_SERVICE_NAME, OUTAGE_INCIDENT_STATUS } from "@Shared/@Types/status-page/types";
export const GLOBAL_MAINTENANCE_IN_PROGRESS = "GLOBAL_MAINTENANCE_IN_PROGRESS";
export const GLOBAL_MAINTENANCE_MESSAGE = "GLOBAL_MAINTENANCE_MESSAGE";
const ignoreMaintenanceScreenListProd = ["b5636042-a3fe-42c3-87d4-f56df1299455"];
const getters = {
  [GLOBAL_MAINTENANCE_IN_PROGRESS]: (state, getters, rootState, rootGetters) => {
    if (_includesInstanceProperty(ignoreMaintenanceScreenListProd).call(ignoreMaintenanceScreenListProd, rootGetters["AccountStore/CURRENT_USER_USERNAME"])) {
      return false;
    }
    const incident = state.externalServicesIncidents.byId[EXTERNAL_SERVICE_NAME.GLOBAL];
    return (incident == null ? void 0 : incident.status) === OUTAGE_INCIDENT_STATUS.MAINTENANCE;
  },
  [GLOBAL_MAINTENANCE_MESSAGE]: state => {
    const incident = state.externalServicesIncidents.byId[EXTERNAL_SERVICE_NAME.GLOBAL];
    return incident == null ? void 0 : incident.description;
  }
};
export default getters;